<template>
  <div class="app-container">
    <div class="top">
      <div class="block">
        <div class="title">
          <div class="left">设备数量</div>
          <div class="right show-btn">今日</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="left">监控数量</div>
          <div class="right show-btn">今日</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="left">操作数据</div>
          <div class="right show-btn">本周</div>
        </div>
        <div class="content">
          -
        </div>
        <div class="bottom">
          <div class="left">昨日数据</div>
          <div class="right">-</div>
        </div>
      </div>
    </div>
    <div class="center">
      <div class="block">
        <div class="title">
          <div class="left">监控抓拍</div>
          <div class="right show-btn">更多</div>
        </div>
        <div class="content">
        </div>
      </div>
    </div>    
    <div class="bottom">
      <div class="block">
        <div class="title">
          <div class="left">告警消息</div>
          <div class="right show-btn">更多</div>
        </div>
        <div class="content">
        </div>
      </div>
      <div class="block">
        <div class="title">
          <div class="left">农事记录</div>
          <div class="right show-btn">更多</div>
        </div>
        <div class="content">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
  background-color: #F5F5F5;
  height: calc(100vh - 56px - 20px);
  .top{
    width: 100%;
    height: 190px;
    padding-top: 10px;
    .block{
      width: 32%;
      margin-left: 1%;
      height: 175px;
      float: left;
      border-radius: 4px;
      background-color: #FFFFFF;
      .title{
        width: 100%;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
          padding-left: 10px;
        }
        .right{
          float: right;
          width: 50%;
        }
        .show-btn{
          border: 1px solid #209323;
          background-color: #209323;
          color: #FFFFFF;
          border-radius: 2px;
          line-height: 21px;
          width: 40px;
          text-align: center;
          font-size: 12px;
          margin-top: 12px;
          margin-right: 10px;
        }
      }
      .content{
        width: 94%;
        margin-left: 3%;
        height: 85px;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 1px;
        border-bottom: 1px solid #F5F5F5;
        line-height: 85px;
      }
      .bottom{
        width: 94%;
        margin-left: 3%;
        float: left;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
        }
        .right{
          float: right;
          width: 50%;
          text-align: right;
          font-size: 14px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
        }
      }
    }
  }
  .center{
    width: 100%;
    height: 190px;
    .block{
      width: 98%;
      margin-left: 1%;
      height: 175px;
      float: left;
      border-radius: 4px;
      background-color: #FFFFFF;
      .title{
        width: 100%;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
          padding-left: 10px;
        }
        .right{
          float: right;
          width: 50%;
        }
        .show-btn{
          border: 1px solid #209323;
          background-color: #209323;
          color: #FFFFFF;
          border-radius: 2px;
          line-height: 21px;
          width: 40px;
          text-align: center;
          font-size: 12px;
          margin-top: 12px;
          margin-right: 10px;
        }
      }
      .content{
        width: 94%;
        margin-left: 3%;
        height: 85px;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }   
  .bottom{
    width: 100%;
    height: calc(100vh - 56px - 20px - 200px - 200px);
    .block{
      width: 48.5%;
      margin-left: 1%;
      height: calc(100vh - 56px - 20px - 200px - 200px);
      float: left;
      border-radius: 4px;
      background-color: #FFFFFF;
      .title{
        width: 100%;
        height: 45px;
        .left{
          float: left;
          width: 50%;
          font-size: 16px;
          font-weight: bold;
          letter-spacing: 1px;
          line-height: 45px;
          padding-left: 10px;
        }
        .right{
          float: right;
          width: 50%;
        }
        .show-btn{
          border: 1px solid #209323;
          background-color: #209323;
          color: #FFFFFF;
          border-radius: 2px;
          line-height: 21px;
          width: 40px;
          text-align: center;
          font-size: 12px;
          margin-top: 12px;
          margin-right: 10px;
        }
      }
      .content{
        width: 94%;
        margin-left: 3%;
        height: 85px;
        font-size: 36px;
        font-weight: bold;
        letter-spacing: 1px;
      }
    }
  }  
}
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/index/Index.vue